import axios from "axios";
import apiURI from "./Api";

export default class GoogleCalendarService {
  async getAuthUrl(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/api/google-calendar/auth`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getStatus(token, userId) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/api/google-calendar/status`,
      headers: { Authorization: "Bearer " + token },
      params: { userId },
    });

    return response.data;
  }

  async getConnection(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/google-calendar/connection`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async deleteConnection(token, userId) {
    const response = await axios({
      method: "delete",
      url: `${apiURI}/api/google-calendar/disconnect`,
      headers: { Authorization: "Bearer " + token },
      params: { userId },
    });

    return response.data;
  }
}
